import { TailSpin } from 'react-loading-icons'

const LoadingSpinnerCentered = (props: { height?: string; width?: string }) => (
  <div
    className='flex justify-center items-center'
    style={{ height: props.height || '100%', width: props.width || '100%' }}
    data-testid='loading-spinner'
  >
    <TailSpin fill='#9C3BFF' stroke='#9C3BFF' {...props} />
  </div>
)

export default LoadingSpinnerCentered
